var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CD2088",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.454 7.977h-6.429V1.42h-7.87v11.917h-1.7V-.28h10.79l6.91 7.201v6.416h-1.7v-5.36zm-1.274-1.7l-3.455-3.601v3.6h3.455zm1.274 14.547h1.7V24h-17.7v-3.176h1.7v1.553h14.3v-1.553z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85 13.85v5.439h18.3V13.85H2.85zm20-1.7v8.839H1.15V12.15h21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18.176V15h1.454c.369-.018.718.174.907.498.19.324.19.728 0 1.052-.19.324-.538.515-.907.497H8.66v1.119L8 18.176zm1.822-2.15c.002-.122-.047-.238-.135-.32-.087-.082-.205-.122-.323-.11h-.703v.857h.703c.118.011.234-.029.322-.11.087-.081.136-.197.136-.317zM11 18.175V15h1.224c.974 0 1.649.633 1.649 1.59 0 .958-.675 1.585-1.649 1.585H11zm2.19-1.584c.019-.27-.078-.535-.265-.726-.187-.19-.446-.29-.71-.27h-.554v1.984h.563c.26.013.515-.087.7-.275.186-.188.285-.447.274-.713h-.008zM14 18.175L14 15 16.201 15 16.201 15.595 14.668 15.595 14.668 16.266 16.172 16.266 16.172 16.861 14.663 16.861 14.663 18.175z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.33e1f458.svg";
export { ForwardRef as ReactComponent };